import { Disclosure, StatusBadge } from "@peer-start/ui";
import type { SkillStatus } from "@peer-start/platform-contracts";
import { useTranslation } from "react-i18next";

export function LegacyHistory({
  items,
}: {
  items: { skillId: string; skillTitle: string; status: SkillStatus }[];
}) {
  const { t } = useTranslation();
  if (!items.length) return null;
  return (
    <Disclosure
      controlId="passport.legacy.toggle"
      title={`${t("passportVig.legacy.title")} (${items.length})`}
      description={t("passportVig.legacy.description")}
    >
      <ul className="mt-4 flex flex-wrap gap-2">
        {items.map((item) => (
          <li key={item.skillId}>
            <StatusBadge compact label={item.skillTitle} status={item.status} />
          </li>
        ))}
      </ul>
    </Disclosure>
  );
}
